import React from "react";
import SidebarComponent from "./SidebarComponent";
import Mobileicon from "../../Images/mobileIcon.svg";
import basketicon from "../../Images/basketicon.svg";
import { SIDEBAR_OPTIONS_LIST } from "../../utilities/constants";

const Offcanvas = (showSidebar) => {
  const handleImageClick = () => {
    const offcanvasElement = document.getElementById(
      "offcanvasWithBothOptions"
    );
    const offcanvas = new window.bootstrap.Offcanvas(offcanvasElement);
    offcanvas.show();
  };

  return (
    <>
      <button
        className="border-0 bg-transparent"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasWithBothOptions"
        aria-controls="offcanvasWithBothOptions"
      >
        <div className="basketicon-container">
          <img
            className="icon_on_cell logoIon"
            src={Mobileicon}
            onClick={handleImageClick}
            alt="basket_icon"
          />
        </div>
      </button>

      <div
        className="offcanvas offcanvas-start"
        data-bs-scroll="true"
        tabIndex="-1"
        id="offcanvasWithBothOptions"
        aria-labelledby="offcanvasWithBothOptionsLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">
            <img
              src={basketicon}
              style={{ maxWidth: 110, objectFit: "contain" }}
              alt="Menu_icon"
              className="menu_icon"
            />
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <SidebarComponent
            optionsList={SIDEBAR_OPTIONS_LIST}
            nestingLevel={0}
            showSidebar={showSidebar}
          />
        </div>
      </div>
    </>
  );
};

export default Offcanvas;
